import React from "react";
import { Box, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { getEntityInitial } from "./criticalPathAvatars";

const EntityAvatar = ({
  name,
  color,
  size = 32,
  title,
  fontSize = "0.72rem",
  inline = false,
}) => {
  const displayName = String(name || "").trim() || "—";
  const bg = color || "#9e9e9e";

  const avatar = (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 800,
        fontSize,
        letterSpacing: 0.2,
        color: "#fff",
        backgroundColor: bg,
        boxShadow: `0 2px 6px ${alpha(bg, 0.35)}`,
        border: `1px solid ${alpha("#000", 0.08)}`,
        userSelect: "none",
        flexShrink: 0,
      }}
    >
      {getEntityInitial(displayName)}
    </Box>
  );

  return (
    <Tooltip arrow placement="top" title={title ?? displayName}>
      {inline ? (
        avatar
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {avatar}
        </Box>
      )}
    </Tooltip>
  );
};

export default EntityAvatar;
